import { all, takeLatest, call, put } from 'redux-saga/effects'
import { get } from 'lodash'
import { fetchHelper } from 'helpers'
import * as types from './constants'
import * as actions from './actions'
import { ROOT_API_URL } from 'constants/index'

function requestGetCountryListFromApi() {
  return fetchHelper
    .fetch(`${ROOT_API_URL}/country/list`, {
      method: 'GET',
    })
    .then(([resp, status]) => ({
      data: resp,
      status,
    }))
}
function* getCountryList({ payload }) {
  try {
    const { data } = yield call(requestGetCountryListFromApi, payload)
    if (get(data, 'code') === 200) {
      yield put(actions.getListCountrySuccess(data.data))
    }
  } catch (error) {
    console.error('updateProfile', error)
  }
}

export default function* rootSaga() {
  yield all([takeLatest(types.GET_LIST_COUNTRY, getCountryList)])
}
